import TownBuyerLandingPage from "./TownBuyerLandingPage";
const CherryHillLanding = () => (
  <TownBuyerLandingPage townName="Cherry Hill" slug="homes-for-sale-cherry-hill" savedLinkId="10358" viewAllUrl="https://homes.prpsj.com/i/homes-for-sale-cherry-hill-ac" />
);
export default CherryHillLanding;
